<script setup lang="ts">
import BaseStack from '~/components/foundations/BaseStack.vue'
import type { BreadcrumbItem } from '~/components/molecules/BaseBreadcrumbs.vue'
import WorkFileDetails from '~/components/molecules/WorkFileDetails.vue'
import TheHeader from '~/components/organisms/Header/TheHeader.vue'
import { useCurrentOperator } from '~/composables/useCurrentOperator'
import type { DailyWorkFile } from '~/entities/dailyWorkFile'
import type { WorkFileIdentification } from '~/entities/workFileIdentification'

const { currentOperator } = useCurrentOperator()

defineProps<{
  checkFileTitle?: string
  workDate?: string
  timeboxName?: string
  checkSheetDisplayTitle?: string
  enabledMenu?: boolean
  dailyWorkFile?: DailyWorkFile
  identifications?: WorkFileIdentification[]
  breadcrumbItems?: BreadcrumbItem[]
}>()

const emit = defineEmits<{
  refreshIdentifications: []
}>()
</script>

<template>
  <BaseStack class="work-file-layout">
    <div class="header-block">
      <TheHeader :current-operator="currentOperator" />
    </div>

    <main class="main-content">
      <div class="content-wrapper">
        <BaseStack gap="l" class="content-block">
          <WorkFileDetails
            v-if="checkFileTitle"
            :check-file-title="checkFileTitle"
            :work-date="workDate"
            :timebox-name="timeboxName"
            :check-sheet-display-title="checkSheetDisplayTitle"
            :enabled-menu="enabledMenu"
            :daily-work-file="dailyWorkFile"
            :identifications="identifications"
            :breadcrumb-items="breadcrumbItems"
            @refresh-identifications="emit('refreshIdentifications')"
          />
          <slot />
        </BaseStack>
      </div>
    </main>
  </BaseStack>
</template>

<style scoped lang="scss">
.work-file-layout {
  height: 100%;

  .header-block {
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .main-content {
    flex-grow: 1;
    overflow-y: auto;

    .content-wrapper {
      padding-bottom: spacingToken.$spacing-4l;

      .content-block {
        height: 100%;
        padding: spacingToken.$spacing-s spacingToken.$spacing-m;
      }
    }
  }
}
</style>
